import React, { useState, useEffect } from 'react';

const CounterInput = ({ 
  label, 
  value, 
  onChange, 
  min = 1, 
  max = 10, 
  disabled = false,
  helperText = '',
  style = {}
}) => {
  const [isChanging, setIsChanging] = useState(false);
  
  // Add visual feedback when value changes
  useEffect(() => {
    setIsChanging(true);
    const timer = setTimeout(() => setIsChanging(false), 300);
    return () => clearTimeout(timer);
  }, [value]);
  const handleIncrement = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleInputChange = (e) => {
    const newValue = parseInt(e.target.value) || min;
    if (newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  return (
    <div style={style}>
      <label style={{ 
        display: 'block', 
        marginBottom: 6, 
        fontWeight: 600,
        color: '#36433B'
      }}>
        {label}
      </label>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #D2CDBF',
        borderRadius: 6,
        backgroundColor: disabled ? '#EEEBE1' : 'white',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        ...(isChanging && !disabled ? { 
          borderColor: '#1A3E2A',
          boxShadow: '0 0 0 3px rgba(26, 62, 42, 0.1)',
          transform: 'scale(1.02)'
        } : {})
      }}>
        <button
          type="button"
          onClick={handleDecrement}
          disabled={disabled || value <= min}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            fontWeight: 600,
            color: disabled || value <= min ? '#A5A89B' : '#36433B',
            cursor: disabled || value <= min ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            if (!disabled && value > min) {
              e.target.style.backgroundColor = '#EEEBE1';
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          −
        </button>
        
        <input
          type="number"
          value={value}
          onChange={handleInputChange}
          min={min}
          max={max}
          disabled={disabled}
          style={{
            flex: 1,
            border: 'none',
            padding: '10px 8px',
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 600,
            backgroundColor: 'transparent',
            color: disabled ? '#5F6B61' : '#1A3E2A'
          }}
        />
        
        <button
          type="button"
          onClick={handleIncrement}
          disabled={disabled || value >= max}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            fontWeight: 600,
            color: disabled || value >= max ? '#A5A89B' : '#36433B',
            cursor: disabled || value >= max ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            if (!disabled && value < max) {
              e.target.style.backgroundColor = '#EEEBE1';
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          +
        </button>
      </div>
      
      {helperText && (
        <small style={{ 
          color: '#5F6B61', 
          fontSize: 12,
          display: 'block',
          marginTop: 4
        }}>
          {helperText}
        </small>
      )}
    </div>
  );
};

export default CounterInput;
